export default "__VITE_ASSET__DBh67wcV__"